













import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Decklist } from '@/types/decklist';
import { DECKLIST } from '@/store/actions';

@Component({
  components: {
  },
})
export default class CardStackHeader extends Vue {
  get decklist(): Decklist {
    return this.$store.state.decklist.decklist;
  }

  private colorStyle(count: number) {
    if (count > 60) {
      return 'color:#882121;';
    }
    return '';
  }

  private changeTitle(event: any) {
    this.$store.commit(DECKLIST.TITLE, event.target.value);
  }
}
